import React from 'react';

const SustainabilityModalPopupComponent = props => (
    <div className="modal-popup-sust"
        style={{ display: props.isOpenedPopup ? "block" : "none" }}>
        <div className="content">
            <div className="body">
                <button onClick={props.onClickBtnClosePopup} className="btn-close-modal">
                    <i></i>
                </button>
                <ul>
                    <li>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-1.png"
                                    alt="Pre-Consumer Waste Recycling Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>
                                    Pre-Consumer Waste Recycling
                                    Denim
                                                </h3>
                                <p>
                                    Pre-Consumer Waste means
                                    recycling cotton is from
                                    textile production processes
                                    such as spinning, fabric,
                                    and garment manufacturing
                                    processes. Wasted cotton,
                                    flying cotton, fabric scrap,
                                    garment scrap can be raw
                                    material for Pre-Consumer
                                    Recycling Denim.
                                                </p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-2.png"
                                    alt="Post-Consumer Waste Recycling Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>
                                    Post-Consumer Waste
                                    Recycling Denim
                                                </h3>
                                <p>
                                    Post-Consumer Waste
                                    Recycling Denim is made from
                                    recycled cotton by wasted
                                    garments and clothes from
                                    consumers’ level in our
                                    life. Post-Consumer Waste
                                    Cotton comes from discarded
                                    textile products.
                                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-3.png"
                                    alt="Recycling Spandex Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>Recycling Spandex Denim</h3>
                                <p>
                                    Lycra EcoMade fiber is
                                    produced from the waste
                                    collected at the manufacture
                                    of the Lycra and blended
                                    with virgin fiber at
                                    specific concentrations.
                                    Recycling Spandex Denim is
                                    made with the wastes but can
                                    offer the same lasting
                                    comfort, fit, and freedom of
                                    movement as the original
                                    Lycra fiber.
                                                </p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-4.png"
                                    alt="Recycling Tencel Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>Recycling Tencel Denim</h3>
                                <p>
                                    The Refibra is the 100%
                                    biobased fibers and involves
                                    Pre- and Post-Consumer Waste
                                    recycled cotton scraps
                                    collected from the garment
                                    manufacturing process, in
                                    addition to the wood pulp
                                    which is a renewable raw
                                    material that comes from
                                    sustainably managed forests.
                                    Recycling Tencel Denim can
                                    drive circular economy
                                    solutions in the denim
                                    industries.
                                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-5.png"
                                    alt="Pet Bottle Recycling Denim from Ocean"
                                />
                            </div>
                            <div className="info">
                                <h3>
                                    Pet Bottle Recycling Denim
                                    from Ocean
                                                </h3>
                                <p>
                                    Each year, at least 8.8
                                    million tons of plastics
                                    make their way into the
                                    ocean. Repreve Our Ocean is
                                    made from PET bottles at
                                    high risk of entering the
                                    ocean. These bottles are
                                    collected within 50
                                    kilometers of waterways or
                                    coastlines in countries or
                                    regions that lack formal
                                    waste or recycling systems.
                                    This denim has not only
                                    protecting ocean but also
                                    quality and performance such
                                    as moisture management,
                                    thermal comfort and
                                    engineered stretch.
                                                </p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-6.png"
                                    alt="BCI Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>BCI Denim</h3>
                                <p>
                                    BCI(Better Cotton
                                    Initiatives) is organized by
                                    WWF and many brands and
                                    retailers in the world to
                                    make better cotton
                                    production and save our
                                    planet as one of the largest
                                    main stream agricultural
                                    products. As a member of BCI
                                    since 2016 and a major
                                    manufacturer of denim
                                    industry, TCE is also
                                    focusing on sustainability
                                    and environment in everyday
                                    production.
                                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-7.png"
                                    alt="Organic Cotton Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>Organic Cotton Denim</h3>
                                <p>
                                    Organic Cotton is farmed
                                    without using synthetic
                                    fertilizers, pesticides, and
                                    GMO seeds natural and
                                    environmentally friendly
                                    cotton. Organic Cotton Denim
                                    has eliminated the risk
                                    associated with hazardous
                                    chemicals used in
                                    conventional cotton. This is
                                    safe for the people working,
                                    and for the soil as it is
                                    not contaminated by toxic
                                    pesticides.
                                                </p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-8.png"
                                    alt="Cottonless Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>Cottonless Denim</h3>
                                <p>
                                    Like cotton, COTTONLESS raw
                                    materials are made from
                                    plant materials. As 100% no
                                    using cotton, Cottonless
                                    Denim reduces cotton
                                    dependence, because cotton
                                    is often produced in a way
                                    that uses lots of water,
                                    energy, and pesticide. It
                                    has a lower environmental
                                    impact such as water and
                                    energy saving.
                                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-9.png"
                                    alt="Coffee Ground Recycling Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>
                                    Coffee Ground Recycling
                                    Denim
                                                </h3>
                                <p>
                                    This denim is cooler than
                                    normal denim. The ICE CAFÉ
                                    fiber’s Nylon combined with
                                    coffee grounds having highly
                                    water absorption function
                                    and offers fast dry
                                    comparing to normal cotton
                                    fiber. It is also
                                    eco-friendly denim concept
                                    for giving a boost to green
                                    technology and sustainable
                                    fashion industry as using
                                    nano particles extracted
                                    from recycling coffee
                                    grounds.
                                                </p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-10.png"
                                    alt="ECOVERO Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>ECOVERO Denim</h3>
                                <p>
                                    ECOVERO is a sustainable
                                    viscose fiber that is made
                                    of the cellulose by wood
                                    came from nearby sustainable
                                    forestry. It can reduce 50%
                                    lower carbon gas emissions
                                    by combining a particularly
                                    sustainable production
                                    process and considerably
                                    shorter haul. And produced
                                    with significantly lower
                                    fossil energy use and water
                                    than generic viscose,
                                    ECOVERO can reduce 50% less
                                    energy and water
                                    consumption. ECOVERO Denim
                                    is environmentally denim, as
                                    well as has a soft, silky,
                                    and luxurious feel.
                                                </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-11.png"
                                    alt="HEMP Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>HEMP Denim</h3>
                                <p>
                                    Hemp can remove some of the
                                    harmful chemicals and heavy
                                    metals from the contaminated
                                    soil. Growing hemp could
                                    help offset carbon emissions
                                    in other areas of the denim
                                    supply chain because it
                                    absorbs more CO2 than a
                                    commercial crop. It uses
                                    about half as much water per
                                    season unlike cotton,
                                    requires no pesticides or
                                    herbicides, and grows fast
                                    from seed to harvest. Hemp
                                    Denim has a similar texture
                                    like linen, it can be
                                    pre-treated and finished
                                    softer hand feels and it is
                                    biodegradable at the end of
                                    the life cycle.
                                                </p>
                            </div>
                        </div>
                        <div className="item">
                            <div className="img">
                                <img
                                    src="/imgs/aboutTCE_SUSTAINABILITY_5-12.png"
                                    alt="E3 Cotton Denim"
                                />
                            </div>
                            <div className="info">
                                <h3>E3 Cotton Denim</h3>
                                <p>
                                    E3 Cotton Denim uses cotton
                                    that satisfies three E,
                                    which are socially
                                    equitable, economically
                                    viable, and environmentally
                                    responsible. This cotton can
                                    be traced from the farmer to
                                    the gin, and right through
                                    to the merchant, mills and
                                    retailer, The end customers
                                    know exactly what their
                                    clothes are made of, how
                                    they are made, and where the
                                    cotton comes from.
                                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
)

export default SustainabilityModalPopupComponent;